// Web v3 copy, canonical comp updated October 2, 2026.
// Outcome claims remain gated by existing authoritative state.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "login.title": "Sign in",
  "login.return": "Continue to {destination}.",
  "login.onWay": "Continue to {destination}.",
  "login.continueTo": "Continue to {destination}",
  "login.differentAccount": "Use another account",
  "login.appFirst": "Signing in happens in the Lura app.",
  "login.openApp": "Open the Lura app on your phone to continue.",
  "login.signedInAs": "You're signed in as {account}.",

  "login.account": "your account",
  "login.signOut": "Sign out",

  "login.provider.apple": "Continue with Apple",
  "login.provider.apple.busy": "Opening Apple…",
  "login.provider.google": "Continue with Google",
  "login.provider.google.busy": "Opening Google…",
  "login.provider.hint": "Continue in the pop-up.",

  "login.or": "or",

  "login.field.email": "Email",
  "login.field.email.placeholder": "you@example.com",
  "login.field.password": "Password",
  "login.field.password.placeholder": "Your password",
  "login.submit": "Sign in",
  "login.submit.busy": "Signing in…",
  "login.forgot": "Forgot password?",

  "login.error.credentials":
    "Check your email and password.",
  "login.error.popupBlocked":
    "Allow pop-ups for Lura, then try again.",
  "login.error.differentMethod":
    "Use your usual sign-in method.",
  "login.error.timeout":
    "Reload to finish signing in.",
  "login.error.generic": "Sign-in didn’t finish. Try again.",

  // copy-1 (Founder-approved, 2026-10-06): why the person is signed out, on
  // /login (shared/hooks/useSignOutNotice.ts). The deliberate line has no
  // prompt to sign back in, by decision.
  "login.notice.sessionEnded": "Your session ended. Sign in to continue.",
  "login.notice.signedOut": "You’re signed out.",

  "reset.title": "Reset your password",
  "reset.intro": "",
  "reset.expired.lead": "This link expired.",
  "reset.expired.body":
    "This link expired.",
  "reset.field.email": "Email",
  "reset.field.email.placeholder": "you@example.com",
  "reset.submit": "Send link",
  "reset.submit.busy": "Sending…",
  "reset.invalid": "Enter a valid email address.",
  "reset.sent.title": "Check your email",
  "reset.sent.request":
    "Look for a reset link at {email}.",
  "reset.sent.unconfirmed": "",

  "reset.sent.body":
    "Look for a reset link at {email}.",
  "reset.sent.hint":
    "",
  "reset.sent.close":
    "",
  "reset.backToSignIn": "Back to sign in",

  "reset.failed": "We couldn’t send the link.",
  "reset.failed.wait": "Try again later.",
} as const;

export type AuthKey = keyof typeof en;

export const es: Partial<Record<AuthKey, string>> = {
  // These paragraphs are intentionally omitted in both locales; no translated prose.
  "reset.intro": "",
  "reset.sent.unconfirmed": "",
  "reset.sent.hint": "",
  "reset.sent.close": "",
  "login.title": "Iniciar sesión",
  "login.continueTo": "Continuar a {destination}",
  "login.appFirst": "El inicio de sesión se hace en la app de Lura.",
  "login.openApp": "Abre la app de Lura en tu teléfono para continuar.",
  "login.signedInAs": "Iniciaste sesión como {account}.",
  "login.account": "tu cuenta",
  "login.signOut": "Cerrar sesión",
  "login.provider.apple": "Continuar con Apple",
  "login.provider.google": "Continuar con Google",
  "login.or": "o",
  "login.field.email": "Correo electrónico",
  "login.field.email.placeholder": "tu@ejemplo.com",
  "login.field.password": "Contraseña",
  "login.field.password.placeholder": "Tu contraseña",
  "login.submit": "Iniciar sesión",
  "reset.title": "Restablece tu contraseña",
  "reset.field.email": "Correo electrónico",
  "reset.field.email.placeholder": "tu@ejemplo.com",
  "reset.backToSignIn": "Volver a iniciar sesión",
  "reset.sent.title": "Revisa tu correo",
  "login.notice.sessionEnded": "Tu sesión terminó. Inicia sesión para continuar.",
  "login.notice.signedOut": "Cerraste sesión.",
  "login.differentAccount": "Usar otra cuenta",
  "login.error.credentials": "Revisa tu correo y contraseña.",
  "login.error.differentMethod": "Usa tu método habitual para iniciar sesión.",
  "login.error.generic": "No se completó el inicio de sesión. Vuelve a intentarlo.",
  "login.error.popupBlocked": "Permite las ventanas emergentes de Lura y vuelve a intentarlo.",
  "login.error.timeout": "Vuelve a cargar la página para terminar de iniciar sesión.",
  "login.forgot": "¿Olvidaste tu contraseña?",
  "login.onWay": "Continúa a {destination}.",
  "login.provider.apple.busy": "Abriendo Apple…",
  "login.provider.google.busy": "Abriendo Google…",
  "login.provider.hint": "Continúa en la ventana emergente.",
  "login.return": "Continúa a {destination}.",
  "login.submit.busy": "Iniciando sesión…",
  "reset.expired.body": "Este enlace venció.",
  "reset.expired.lead": "Este enlace venció.",
  "reset.failed": "No pudimos enviar el enlace.",
  "reset.failed.wait": "Vuelve a intentarlo más tarde.",
  "reset.invalid": "Ingresa una dirección de correo electrónico válida.",
  "reset.sent.body": "Busca el enlace para restablecer tu contraseña en {email}.",
  "reset.sent.request": "Busca el enlace para restablecer tu contraseña en {email}.",
  "reset.submit": "Enviar enlace",
  "reset.submit.busy": "Enviando…",
};
